import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from '../../../../components/UI'
import ErrorMessageWithExclamation from '../../../../components/UI/ErrorMessageWithExclamation'
import DropDown from '../../../../components/Input/DropDown'

import { selectUserData } from '../../../../routing/fetchingfunction/user/user.reducer'
import { setStep, updateAbout } from '../../../../routing/fetchingfunction/user/user.action'

import { useCountries } from '../../../../hooks'

import { LocationScheme } from '../../../../routing/utils/validators'

const Location = () => {
  const dispatch = useDispatch()

  const userData = useSelector(selectUserData)

  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
    clearErrors,
  } = useForm({
    defaultValues: {
      country_of_origin: userData?.profile?.country_of_origin,
      country_of_residence: userData?.profile?.country_of_residence,
    },
    resolver: yupResolver(LocationScheme),
  })

  useEffect(() => {
    if (userData?.profile) {
      reset({
        country_of_origin: userData?.profile.country_of_origin || '',
        country_of_residence: userData?.profile.country_of_residence || '',
      })
    }
  }, [userData?.profile, reset])

  const [isLoading, setIsLoading] = useState(false)

  const { formattedCountries } = useCountries()

  const handleFormSubmit = (data) => {
    setIsLoading(true)

    dispatch(
      updateAbout({
        id: userData.id || userData.pk,
        profile: {
          ...userData.profile,
          ...data,
        },
      })
    )
      .then((data) => {
        if (!data.error) {
          //commented out due to error after update
          // dispatch(setStep(1))
          console.log('first')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <div className="w-full mt-[20px] bg-[#FEEBDD] rounded-[10px] p-[32px]">
      <h4 className="text-base font-bold text-primary-100">Location</h4>

      <h5 className="mt-[8px] text-sm font-normal text-primary-100">
        Your location will be visible to all students.
      </h5>

      <form
        className="
    w-full
    flex flex-col items-start
    mt-[20px]
    rounded-[10px]
    gap-y-[20px]
    border-[1px] border-[#FFCA84]
    p-[20px]
    max-w-full
    sm:max-w-full
    mx-auto
  "
        onSubmit={handleSubmit(handleFormSubmit)}
      >
        <div className="w-full max-w-full sm:max-w-[463px]">
          <span className="inline-block text-base font-semibold text-primary-100 mb-[4px]">
            Country of Origin
          </span>

          <Controller
            control={control}
            name="country_of_origin"
            render={({ field: { value, onChange } }) => {
              return (
                <DropDown
                  menuItems={formattedCountries}
                  placeholder="Select Country of Origin"
                  value={value}
                  setValue={onChange}
                />
              )
            }}
          />

          {errors.country_of_origin && (
            <ErrorMessageWithExclamation text={errors.country_of_origin.message} />
          )}
        </div>

        <div className="w-full max-w-full sm:max-w-[463px]">
          <span className="inline-block text-base font-semibold text-primary-100 mb-[4px]">
            Country of Residence
          </span>

          <Controller
            control={control}
            name="country_of_residence"
            render={({ field: { value, onChange } }) => {
              return (
                <DropDown
                  menuItems={formattedCountries}
                  placeholder="Select Country of Residence"
                  value={value}
                  setValue={onChange}
                />
              )
            }}
          />

          {errors.country_of_residence && (
            <ErrorMessageWithExclamation text={errors.country_of_residence.message} />
          )}
        </div>

        <Button
          type="submit"
          className="!text-sm !font-semibold min-w-[129px]"
          isLoading={isLoading}
        >
          Save Changes
        </Button>
      </form>
    </div>
  )
}

export default Location
